// Footer.js
import React from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { MdOutlinePhone } from "react-icons/md";
import { FaMapLocation } from "react-icons/fa6";
import { TfiEmail } from "react-icons/tfi";

const Footer = () => {
  return (
    <>
      <footer className="bg-dark text-white py-4">
        <Container fluid>
          <Row className="justify-content-center">
            <Col md={3} className="text-center">
              <MdOutlinePhone size={30} className="mb-3" />
              <br />
              <h5>Contact Us</h5>
              <ul className="list-unstyled">
                <li>Email: barassociationd.dun@gmail.com</li>
                <li>Phone: 07533881186</li>
              </ul>
            </Col>
            <Col md={4} className="text-center">
              <FaMapLocation size={30} className="mb-3" />
              <br />
              <h5>Address</h5>
              <p>
                Bar Association Dehardun, Court Compound Near SSP Office, Court
                Road Dehardun, Uttarakhand
              </p>
            </Col>

            <Col md={2} className="text-center">
              <TfiEmail size={30} className="mb-3" />

              <h5>Follow Us</h5>
              <ul className="list-unstyled">
                <li>
                  <a
                    href="https://www.facebook.com/p/%E0%A4%B5%E0%A4%BF%E0%A4%A7%E0%A4%BF-%E0%A4%AD%E0%A4%B5%E0%A4%A8-%E0%A4%A6%E0%A5%87%E0%A4%B9%E0%A4%B0%E0%A4%BE%E0%A4%A6%E0%A5%82%E0%A4%A8-100083055402675/?locale=cs_CZ&_rdr"
                    className="text-white"
                    target="_blank"
                  >
                    Facebook
                  </a>
                </li>
                <li>
                  <a href="#" className="text-white">
                    Whatsapp
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
          {/* <Row>
            <Col className="text-center py-3">
              <p className="mb-0">
                Copyright ©2024 Bar Association Dehardun. All Rights Reserved
              </p>
            </Col>
          </Row> */}
        </Container>
      </footer>
      <div style={{ backgroundColor: "#222222" }}>
        <Nav
          className="justify-content-center text-light py-2 fs-6 px-5"
          activeKey=""
        >
          <Nav.Item className="ps-md-5">
            <Nav.Link href="#" className="text-white">
              Copyright ©2024 Bar Association Dehardun. All Rights Reserved
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
    </>
  );
};

export default Footer;
